import { IPresenca, InputPresenca } from '../../common/types/Presenca'
import GenericService from '@/shareds/GenericService'

export const PATH_PRESENCA = '/presencas'

class PresencaService extends GenericService<IPresenca, InputPresenca> {

	constructor() {
		super(PATH_PRESENCA)
	}

	async getByEventoEIrmao(idEvento: string, idIrmao: string): Promise<IPresenca | null> {
		try {
			const result = await this.axios.get<IPresenca[]>(this.route, {
				params: {
					evento: idEvento,
					irmao: idIrmao,
				},
			})
			return result.data[0] || null
		} catch (error) {
			throw error
		}
	}

	async getByEvento(idEvento: string) {
		try {
			const result = await this.axios.get<IPresenca[]>(this.route, {
				params: {
					evento: idEvento,
					intencoes: {
						$not: {$size: 0},
					},
				},
			})
			return result.data
		} catch (error) {
			throw error
		}
	}
}

export default new PresencaService()
